import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** Handles Emergent Auth callback: reads session_id from URL fragment,
 *  exchanges it via backend, then routes to /dashboard. */
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/", { replace: true }); return; }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        await api.post("/auth/emergent-session", { session_id: sessionId });
        // Clean fragment from URL
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        nav("/dashboard", { replace: true });
      } catch (e) {
        nav("/?auth_error=1", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-zinc-400 text-sm" data-testid="auth-callback">
      <span className="caret">Signing you in</span>
    </div>
  );
}
